import { coreInitiativesCommentsGetAsyncSlice } from './get';
import { CoreInitiativesCommentsName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { InitiativeComment } from '@types';

export const coreInitiativesCommentsUpdateSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesCommentsName,
	state: coreInitiativesCommentsGetAsyncSlice.asyncState,
	target: (update: InitiativeComment) => (comment) => comment.id === update.id,
	update: (update: InitiativeComment) => (comment) => ({
		...comment,
		...update
	})
});
